import { render, staticRenderFns } from "./NotificationTypeList.vue?vue&type=template&id=64d0ed06&scoped=true&"
import script from "./NotificationTypeList.vue?vue&type=script&lang=js&"
export * from "./NotificationTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d0ed06",
  null
  
)

export default component.exports